var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9018 6.76773L7.22584 0.0973111C7.16309 0.0346446 7.07835 0 6.9896 0C6.90086 0 6.81609 0.0353319 6.75337 0.0979671L0.0974372 6.76773C0.001999 6.86304 -0.0260288 7.0063 0.0253659 7.13095C0.0774174 7.25556 0.198881 7.33622 0.333671 7.33622H4.00396V15.6668C4.00396 15.8507 4.15345 16 4.33763 16H9.67626C9.86045 16 10.0099 15.8507 10.0099 15.6668V7.33619H13.6662C13.801 7.33619 13.9225 7.25487 13.9745 7.13026C14.0266 7.00565 13.9972 6.86304 13.9018 6.76773Z",
    fill: "#51C35C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreen);
export default __webpack_public_path__ + "static/media/arrowGreen.0000d3b5e9414105b1120ebefb483aa8.svg";
export { ForwardRef as ReactComponent };